export const UPDATE_CART = 'UPDATE_CART';



// WEBPACK FOOTER //
// ./src/components/Cart/total/actionTypes.js